import * as React from 'react';
import { Validation, ValidationLevel } from 'ui';
import { FIELD_TYPE } from 'app/infrastructure/simple-form';
import { SerializeType } from 'app/infrastructure/simple-form/types';
import { AlternativeIdItemProps } from './types';
import { alternativeIdFieldName } from './constants';

import style from './alternative-id-item.scss';
import { sfNames } from 'app/area/administration/edit/sf-names';
import { getValidationProps } from 'app/area/administration/edit/user/alternative-id/validation-props';

export class AlternativeIdItem extends React.PureComponent<AlternativeIdItemProps> {

  private onRemove = () => {
    !!this.props.onRemove && this.props.onRemove(this.props.data);
  };

  public render() {

    const { data, formValues = {}, validateFields = [], validation, readOnly, translation,
      formComponent: SimpleForm, meatballMenu: MeatballMenu } = this.props;

    if (!data) {
      return null;
    }

    const personIdFormValue = formValues[alternativeIdFieldName(sfNames.personId, data.id)] as string;
    const nameFormValue = formValues[alternativeIdFieldName(sfNames.name, data.id)] as string;

    const validationPersonId = validation && validation.messages
      && validation.messages.filter(m => m.parameters && m.parameters.personId === personIdFormValue?.trim?.());

    const validationName = validation && validation.messages
      && validation.messages.filter(m => m.parameters && m.parameters.name === nameFormValue?.trim?.());

    const hasPersonIdErrors = !!validationPersonId && validationPersonId.length > 0;
    const hasNameErrors = !!validationName && validationName.length > 0;

    return <div className={style.item}>
      {!readOnly && <div className={style.header}>
        <MeatballMenu closeAfterClick={true}>
          <li>
            <button id="remove-button" type="button" className="dropdown-item" onClick={this.onRemove}>
              {translation.remove}
            </button>
          </li>
        </MeatballMenu>
      </div>}
      <div className="row">
        <div className={`col-lg-5 col-sm-12 ${hasPersonIdErrors ? 'has-danger' : ''}`}>
          <SimpleForm
            name={alternativeIdFieldName(sfNames.personId, data.id)}
            maxLength={80}
            type={FIELD_TYPE.TEXTAREA}
            label={{ text: translation.alternative_id, required: !readOnly }}
            initialValue={data && data.personId}
            validationProps={getValidationProps(
              sfNames.personId,
              validateFields,
              data
            )}
            readOnly={readOnly}
          />
          {hasPersonIdErrors && <div className={style.validation}>
            <Validation level={ValidationLevel.error} messages={validationPersonId} />
          </div>}
        </div>
        <div className={`col-lg-5 col-sm-12 ${hasNameErrors ? 'has-danger' : ''}`}>
          <SimpleForm
            name={alternativeIdFieldName(sfNames.name, data.id)}
            maxLength={254}
            type={FIELD_TYPE.TEXTAREA}
            label={{ text: translation.name, required: !readOnly }}
            initialValue={data && data.name}
            serialize={{
              type: SerializeType.VALUE_PAIRS,
              formName: sfNames.alternativeIds,
              valueKey: sfNames.name,
              groupKey: sfNames.personId,
              groupField: alternativeIdFieldName(sfNames.personId, data.id)
            }}
            validationProps={getValidationProps(
              sfNames.name,
              validateFields,
              data
            )}
            readOnly={readOnly}
          />
          {hasNameErrors && <div className={style.validation}>
            <Validation level={ValidationLevel.error} messages={validationName} />
          </div>}
        </div>
      </div>
    </div>;
  }
}
